import { Autocomplete, AutocompleteProps, FieldProps, InputValue } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export type FormAutocompleteFieldProps = Omit<
    FieldProps & AutocompleteProps,
    | 'onBlur'
    | 'error'
    | 'breakpointRange'
    | 'registerScrollAway'
    | 'deregisterScrollAway'
    | 'pauseScrollAway'
    | 'startScrollAway'
> &
    ControllerProps<NonNullable<AutocompleteProps['value']>> & {
        onSearchChange?: (searchValue: string) => void;
        disableInputSearch?: boolean;
        value?: InputValue;
    };

export const FormAutocompleteField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormAutocompleteFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });

    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: handleChange,
        value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <Autocomplete {...props} />;
};
